const steps = [
  {
    icon: 'calendar-day',
    label: 'Evento'
  },
  {
    icon: 'user',
    label: 'Participantes'
  },
  {
    icon: 'store',
    label: 'Lojas'
  }
];

export default steps;